module.exports = __webpack_public_path__ + "img/registration-03.795e241a.png";